import React, { useRef } from 'react';
import { useTranslation } from 'next-i18next';

const FocusControl = ({ onReset, ariaLabel }) => (React.createElement("button", { className: "sr-only", type: "button", onFocus: onReset, onClick: onReset, "aria-label": ariaLabel, "data-focus-control": true }));
// This component is used for setting a focus in the current component area
const FocusTrap = ({ children }) => {
    const { t } = useTranslation('');
    const ref = useRef(null);
    const onResetFocus = (position) => {
        const selector = 'a[href], button:not([data-focus-control]):not([disabled]), input, textarea, select, details,[tabindex]:not([tabindex="-1"])';
        if (!ref.current) {
            return;
        }
        if (position === 'bottom') {
            ref.current.querySelector(selector).focus();
        }
        else {
            [...ref.current.querySelectorAll(selector)].at(-1).focus();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FocusControl, { ariaLabel: t('$common.goBottom'), onReset: () => {
                onResetFocus('top');
            } }),
        React.createElement("div", { ref: ref, id: "focusTrap", className: "focus-trap-wrapper" }, children),
        React.createElement(FocusControl, { ariaLabel: t('$common.goTop'), onReset: () => {
                onResetFocus('bottom');
            } })));
};

export { FocusTrap as default };
//# sourceMappingURL=index.js.map
